import { showElement } from '../../../../../includes/assets/js/modules/dpitHidden';
import { getParentsAndChildrenLinkElements } from '../dpitUtilsPublic';
import { MODIFIERS, TIMING, CLASSES_CORE } from './constants';
import EventListeners from './EventListeners';
import ExclusiveClickListener from './ExclusiveClickListener';


export default class DpitUserInteraction {

	constructor(options, tooltipRefEl, animation, onIterateStep, onIterateStepInProgress, onBeforeUnloadByLinkClick) {
		if (options.debugEn) console.log('[dpit] INIT DpitUserInteraction');
		this.onBeforeUnloadByLinkClick = onBeforeUnloadByLinkClick;
		this.tooltipRefEl = tooltipRefEl;
		this.options = options;
		this.animation = animation;
		this.onIterateStep = onIterateStep;
		this.onIterateStepInProgress = onIterateStepInProgress;
		this.isIterateStepInAction = false;
		this.hoverListeners = new EventListeners();
		this.linkClickListener = new ExclusiveClickListener(this.processTargetLinkClick.bind(this), true, false, false, true);
		this.iterateClickListener = new ExclusiveClickListener(this.iterateStepAfterUserAction.bind(this));
		this.blockClickListener = new ExclusiveClickListener();
	}

	update(stepItem) {
		this.destroy();
		this.stepItem = { ...stepItem };
		this.element = stepItem?.element;
		this.updateIterateAfterClick();
		this.updateIterateAfterHover();
		this.updateLinkClick();
	}


	destroy() {
		this.clearIterateAfterClick();
		this.clearIterateAfterHover();
		this.clearTargetLinkClickAdjustment();
		this.iterateClickListener.clear(true);
		this.blockClickListener.clear(true);
		this.hoverListeners.removeAll();
	}



	updateDisableInteractionLayer(stepItem, wrapEl, moveLayer2TargetFce) {
		if (stepItem && stepItem.enable_interaction.val != '1') {
			this.insertDisableInteractionLayer(wrapEl, moveLayer2TargetFce);
		} else {
			this.removeDisableInteractionLayer();
		}
	}


	insertDisableInteractionLayer(wrapEl, moveLayer2TargetFce) {
		if (!this.disableInteractionLayer && this.tooltipRefEl) {
			this.disableInteractionLayer = document.createElement('div');
			this.disableInteractionLayer.className = CLASSES_CORE.disableInteraction;
			wrapEl.insertBefore(this.disableInteractionLayer, this.tooltipRefEl);
		}
		if (moveLayer2TargetFce instanceof Function) moveLayer2TargetFce(this.disableInteractionLayer);
	}

	removeDisableInteractionLayer() {
		if (this.disableInteractionLayer) {
			this.disableInteractionLayer.parentNode.removeChild(this.disableInteractionLayer);
			this.disableInteractionLayer = null;
		}
	}

	updateLinkClick() {
		if (this.stepItem?.element && !this.isBlockClicks() && !this.isIterateAfterClick(this.stepItem)) {
			this.startTargetLinkClickAdjustment();
		} else {
			this.clearTargetLinkClickAdjustment();
		}
	}

	startTargetLinkClickAdjustment() {
		this.linkClickListener.clear(true);
		const allElementsToBlock = getParentsAndChildrenLinkElements(this.stepItem?.element, true);
		if (allElementsToBlock) {
			this.linkClickListener.addElements(allElementsToBlock);
		}
	}

	clearTargetLinkClickAdjustment() {
		this.linkClickListener.clear(true);
	}

	/**
	 * Force to open link element in new tab
	 * @param {Event} event click event
	 * @param {Element} linkElement element where event occurs
	 */
	processTargetLinkClick(event, linkElement) {

		if (this.disabled && this.userInteractionTryWhenDisabledFce) {
			this.userInteractionTryWhenDisabledFce();
		}
		const isBlockClicks = this.isBlockClicks();

		if (!this.isIterateStepInAction && !this.disabled && linkElement && !isBlockClicks && !this.isIterateAfterClick(this.stepItem)) {
			const hrefAttribute = linkElement.getAttribute('href');

			if (hrefAttribute && event) {
				const targetAttribute = linkElement.getAttribute('target');
				if (targetAttribute === '_blank' || this.isOpenTargetLinkClicksInNewTab()) {
					if (this.options.dpDebugEn) console.log('[dpit] TARGET CLICK: <a> element inside a target was clicked and opened in new tab.');
					if (!event.defaultPrevented) {
						try {
							window.open(hrefAttribute, '_blank');
							return false;
						} catch (exception) {
							console.error(exception);
						}
					}
				} else if (this.onBeforeUnloadByLinkClick instanceof Function) {
					this.onBeforeUnloadByLinkClick(hrefAttribute);
					return false;
				}
			}
		} else {
			if (event && isBlockClicks) {
				event.preventDefault();
				event.stopImmediatePropagation();
				return false;
			}
		}
		return true;
	}

	clearIterateAfterClick() {
		if (this.element) {
			this.element.classList.remove(
				CLASSES_CORE.target + MODIFIERS.click,
				CLASSES_CORE.target + MODIFIERS.blockClick
			);
		}
	}

	updateIterateAfterClick() {
		if (this.element) {
			this.iterateClickListener.clear(true);
			if (this.isIterateAfterClick(this.stepItem)) {
				this.iterateClickListener.addElement(this.element);
				this.element.classList.add(CLASSES_CORE.target + MODIFIERS.click);
			}
			else if (this.isBlockClicks(this.stepItem)) {
				this.blockClickListener.addElement(this.element);
				this.element.classList.add(CLASSES_CORE.target + MODIFIERS.blockClick);
			}
		}
	}

	disable(userInteractionTryWhenDisabledFce) {
		this.disabled = true;
		this.userInteractionTryWhenDisabledFce = userInteractionTryWhenDisabledFce;
	}

	enable() {
		this.disabled = false;
		this.userInteractionTryWhenDisabledFce = null;
	}


	iterateStepAfterUserAction() {

		if (this.disabled && this.userInteractionTryWhenDisabledFce) this.userInteractionTryWhenDisabledFce();

		if (!this.isIterateStepInAction && !this.disabled && this.stepItem) {
			this.isIterateStepInAction = true;
			let delay = this.stepItem.enable_interaction?.ext?.iterate_after_click_delay_ms ?? TIMING.defaultIterateAfterClick;
			this.animation.start();
			//hideElement(this.stepItem?.element);
			if (this.onIterateStepInProgress instanceof Function) {
				this.onIterateStepInProgress(true);
			}
			this.destroy();
			setTimeout(() => {
				this.animation.stop();
				showElement(this.stepItem?.element);
				if (this.onIterateStepInProgress instanceof Function) {
					this.onIterateStepInProgress(false);
				}
				if (this.onIterateStep instanceof Function) {
					this.onIterateStep();
				}
				this.isIterateStepInAction = false;
			}, delay);
		}
		return false;
	}

	isInteractionFeatureEnabled(featureId) {
		return this.stepItem
			&& this.stepItem.element
			&& this.stepItem.enable_interaction.val == '1'
			&& this.stepItem.enable_interaction.ext
			&& this.stepItem.enable_interaction.ext[featureId] == '1';
	}

	isIterateAfterClick() {
		return this.isInteractionFeatureEnabled('iterate_after_click');
	}

	isOpenTargetLinkClicksInNewTab() {
		return this.isInteractionFeatureEnabled('open_target_link_clicks_in_new_tab');
	}

	isBlockClicks() {
		return this.isInteractionFeatureEnabled('iterate_after_click_stop_propagation');
	}


	updateIterateAfterHover() {
		if (this.element) {
			if (this.isIterateAfterHover(this.stepItem)) {
				this.hoverListeners.add(this.element, 'mouseenter', this.iterateStepAfterUserAction.bind(this));
				this.element.classList.add(CLASSES_CORE.target + MODIFIERS.hover);
			} else {
				this.clearIterateAfterHover();
			}
		}
	}

	clearIterateAfterHover() {
		if (this.element) {
			this.element.classList.remove(CLASSES_CORE.target + MODIFIERS.hover);
		}
	}

	isIterateAfterHover() {
		return this.stepItem
			&& this.stepItem.element
			&& this.stepItem.enable_interaction.val == '1'
			//&& !this.stepItem.isDummyElement
			&& this.stepItem.enable_interaction.ext?.iterate_after_hover == '1';
	}

}
